<template>
	<!--pc-->
	<div class="chat-box"  v-if="_isMobile()=== null"> 
		<!-- <el-dialog style="width:820px;" v-if="handleShow" :visible.sync="handleShow" :close-on-click-modal="false"
			:close-on-press-escape="false" class="chat-dialog" width="100%" @close='close' :show-close="false" :mode> -->
			<!-- <div class="head" slot="title">
				<img style="height:60px;float:left;cursor:pointer;" @click="openIndex"
					src="../assets/images/logo.png" />
			</div> -->
        <div class="chat">
            <div class="chat-content" id='chat-content' ref='chat-content'>

                <div class="message-wrapper" id='message-wrapper' ref='message-wrapper' style="overflow: hidden; padding-top: 20px;">
                    <div class="message-item" v-for="(msg,index) in messageList" :key="index"
                        :class="[msg.web.direction!='forward' ? 'my-msg' : 'your-msg']">
                        <div class="show-time-box" v-if="msg.web.show_time"><span class="time-tip">{{msg.web.show_time}}</span></div>
                        <div class="ft-14 reverse" v-if="msg.web.direction!='forward'">
                            <el-avatar style="vertical-align: top;" icon="el-icon-user-solid" :src="msg.uinfo.head" :size="40">
                            </el-avatar>
                            <div class="message">
                                <div class="message-ep">
                                    {{msg.uinfo.name}}
                                </div>
                                <div class="msgItem">
                                    <span v-html="msg.msg" class="content"></span>
                                        <!--@click="getMsg(msg.message)"-->
                                </div>
                            </div>
                            
                        </div>
                        <div class="ft-14 forward" v-else>
                            <!-- 后台管理员发的消息 -->
                            <el-avatar style="vertical-align: top;margin-right:10px;" :src="msg.uinfo.head"
                                icon="el-icon-user-solid" :size="40"></el-avatar>
                            
                            <div class="message">
                                <div class="message-ep">{{$t('客服')}}</div>

                                <div class="msgItem">
                                    <span v-html="msg.msg" class="content"></span>
                                        <!--@click="getMsg(msg.message)"-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <footer :class="['footer',{'inputFocus':inputFocus}]" -->
            <footer class="footer" style="height:138px;position:relative;padding:10px;">
                <!--style="background: white;"-->
                <div class="message-wrap">
                    <!-- <span @click="getText" class="M_text">M</span>  -->
                    <template>
                        <div  class="edit_container inputFocus">
                        <!-- <div :class="['edit_container',{'inputFocus':inputFocus}]"> -->
                            <textarea id="text_area" v-model="content" @focusin="inputFocus=true" @focusout="inputFocus=false"
                                @keyup.ctrl.enter="sendMsg"></textarea>
                            <!-- <quill-editor 
                            v-model="content" 
                            ref="myQuillEditor" 
                            @change="onEditorChange($event)"
                            :options="editorOption">
                        </quill-editor> -->
                        </div>
                    </template>
                </div>
                <el-button class="sendMsg" @click="sendMsg" size="mini" type="primary">{{$t('user_Index_SEND')}}
            <!-- 	{{screenHeight}} -->
                </el-button>
            </footer>
        </div>
		<!-- </el-dialog> -->

		<div v-if="KefuInfo.customer_code" class="kefu-info">
			<ul>
				<li><i class="iconitem icon-email"></i><span>{{KefuInfo.email}}</span></li>
				<li><i class="iconitem icon-phone"></i><span>{{KefuInfo.phone}}</span></li>
				<li><i class="iconitem icon-face"></i><span>{{KefuInfo.facebook}}</span></li>
				<li><img style="width: 40px; margin-right: 5px;" src="data:image/png;base64,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" /><span>0086-18094507770</span></li>
				<li style="text-align:center;">
					<p class="m-b-10">{{$t('kfewm')}}</p>
					<img :src="$host.file+KefuInfo.customer_code[0]" alt="">
				</li>
				<li style="text-align:center;">
					<p class="m-b-10">{{$t('azxz')}}</p>
					<img :src="$host.file+KefuInfo.Android_code" alt="">
				</li>
				<li style="text-align:center;">
					<p class="m-b-10">{{$t('pgxz')}}</p>
					<img :src="$host.file+KefuInfo.ios_code" alt="">
				</li>
				<!-- <li style="text-align:center; display: flex; justify-content: space-between">
					<div>
						<p class="m-b-10">{{$t('azxz')}}</p>
						<img :src="$host.file+KefuInfo.Android_code" alt="">
					</div>
					<div>
						<p class="m-b-10">{{$t('pgxz')}}</p>
						<img :src="$host.file+KefuInfo.ios_code" alt="">
					</div>
				</li> -->
			</ul>
			
			<div style="position: absolute; bottom: 10px; left: 0; padding: 15px; display: flex; flex-direction: row; font-size: 14px;">
				<div style="word-break:keep-all;">{{$t('注')}}：</div><div>{{$t('VISITORCHAT_TIP')}}</div>
			</div>
		</div>
		<!-- <el-dialog :visible.sync="dialogVisible" v-if="dialogVisible" class="showImg" v-dialogDrag :modal="false"
			width="80%">
			<span v-html="showmessage" class="content"></span>
		</el-dialog> -->

	</div>
    
	<!--手机端-->

   <div v-else class="chat-box-mobile">
	      <div class="wrap">
	         <div class="title">
	           <div>
	             <van-icon
	               name="arrow-left"
	               size="20"
	               style="margin-left: 10px"
	               
	             />
	           </div>
	           <div v-if="user_info.info">{{user_info.info.nickname?user_info.info.nickname:"游客"}}</div>
	           <div>
	             <van-icon
	               name="ellipsis"
	               size="22"
	               style="margin-right: 10px"
	               @ 
	             />
	           </div>
	         </div>
	         <div class="content_box" id="box" ref="scrollBox">
	           
	           <div
	             :class="item.direction == 'forward' ? 'userbox2' : 'userbox'"
	             v-for="(item, index) in messageList"
	             :key="index"
	           >
	              <div :class="item.direction == 'forward' ? 'nameInfo2' : 'nameInfo'">
						  <div style="font-size: 12px">{{item.sender_info.nickname?item.sender_info.nickname:$t("游客")}}</div>
						  <div  :class="item.direction == 'forward' ? 'contentText2' : 'contentText'">
							 <span v-html="item.record.content" class="content"></span>
						  </div>
	               </div>
				    <div>
					  <van-image round width="50px" height="50px" :src="item.sender_info.avatar" />
					</div>
	           </div>
			   
			   
			   
			   
	         </div>
	         <div class="bottom">
	           <van-field
	             v-model="content" 
	             center
	             type="textarea"
	             :autosize="{ maxHeight: 100, minHeight: 25 }"
	             placeholder="请输入内容"
	             rows="1"
	           >
	             <template #button>
	               <van-button size="small" type="primary"  @click="sendMsg"  >{{$t('user_Index_SEND')}}</van-button>
	             </template>
	           </van-field>
	         </div>
	       </div>
	     
	   
   </div>

</template>

<script>
import {
	//messageList,
	tourists
} from "@/api/chat"
import {
	mapState
} from "vuex";
import Fingerprint2 from 'fingerprintjs2'
import io from 'socket.io-client'
	
export default {
	props: {
		dialogCat: {
			default: false
		},
		type: ''
	},
	data() {
		return {
			showmessage: '',
			inputFocus: false,
			dialogVisible: false,
			badgeStatus: 'success',
			handleShow: true,
			dialogTemplate: false,
			messageList: [],
			content: '',
			editorOption: {
				modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike'],
						['image']
					],
				},
				placeholder: '',

			},
			instance: "",
			salesmanList: [],
			timer: null,
			handlelog: true,
			userInfo: JSON.parse(localStorage.getItem('ChatUser')) ? JSON.parse(localStorage.getItem('ChatUser')) : {},
			ws: "",
			socket_url: process.env.VUE_APP_CHAT_SOCKET_API,
			lockReconnect: false,
			socket_heart:null, // 心跳
			user_info: {},
			param: {
				conversation_id: 15,
				page: 1,
				limit: 30
			},
				//聊天数据
			scrollTop:0,
			screenHeight: window.innerHeight-131  
		};
	},
	computed: {
		...mapState('global', ['KefuInfo'])
	},
	watch: {
		// dialogCat(val) {
		// 	this.handleShow = val
		// 	this.getGroupLists()
				
		// }
	},
	mounted() {
		//游客登录
			setTimeout(function(){
				var myField = document.querySelector('#text_area');
				myField.focus();
			},1000)
		
		this.userLogin();
		
		if(this._isMobile()){ 
			//手机端
			//this.setPageScrollTo()
			//创建监听内容部分滚动条滚动
			//this.$refs.scrollBox.addEventListener('scroll',this.srTop)
		}else{
			this.$store.dispatch('global/getCustomer').then(() => {
			
			});
		}
	},

	methods: {
		_isMobile() {
			let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
			return flag;
		},
		//滚动条默认滚动到最底部
		setPageScrollTo(s, c) {
			//获取中间内容盒子的可见区域高度
			this.scrollTop = document.querySelector("#box").offsetHeight;
			setTimeout((res) => {
			//加个定时器，防止上面高度没获取到，再获取一遍。
			if (this.scrollTop != this.$refs.scrollBox.offsetHeight) {
				this.scrollTop = document.querySelector("#box").offsetHeight;
			}
			}, 100);
			//scrollTop：滚动条距离顶部的距离。
			//把上面获取到的高度座位距离，把滚动条顶到最底部
			this.$refs.scrollBox.scrollTop = this.scrollTop;
		},
		//滚动条到达顶部
		srTop(){
			//判断：当滚动条距离顶部为0时代表滚动到顶部了
			if(this.$refs.scrollBox.scrollTop==0){
			//逻辑简介：
			//到顶部后请求后端的方法，获取第二页的聊天记录，然后插入到现在的聊天数据前面。
			//如何插入前面：可以先把获取的数据保存在 A 变量内，然后 this.chatList=A.concat(this.chatList)把数组合并进来就可以了
	
			//拿聊天记录逻辑:
			//第一次调用一个请求拉历史聊天记录，发请求时参数带上页数 1 传过去，拿到的就是第一页的聊天记录，比如一次拿20条。你显示出来
			//然后向上滚动到顶部时，触发新的请求，在请求中把分页数先 +1 然后再请求，这就拿到了第二页数据，然后通过concat合并数组插入进前面，依次类推，功能完成！
			console.log('到顶了，滚动条位置 :',this.$refs.scrollBox.scrollTop);
			}
		},
		async userLogin() {
			var _this = this;
			Fingerprint2.get(function(components) {
				const values = components.map(function(component, index) {
					if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
						return component.value.replace(/\bNetType\/\w+\b/, '')
					}
					return component.value
				})
				// 生成最终id murmur   
				const murmur = Fingerprint2.x64hash128(values.join(''), 31);
				//console.log('浏览器指纹码：'+murmur )
				_this.$api["post"]("visitor/login", {
					fingerprint: murmur
				}).then(({
					data
				}) => {
					localStorage.setItem('ChatToken', data.data.token);
					// localStorage.setItem('ChatTokenTime',Date.now());
					localStorage.setItem('ChatUser', JSON.stringify(data.data));
					_this.chat_token = data.data.token;
					_this.user_info = data.data;
					_this.param.conversation_id = data.data.conversation_id;
					_this.connSocket();
					// _this.listen();
				});
			})
		},
		connSocket(){
			// 创建连接
			try {
				if(window.WebSocket) {
					// console.log(this.socket_url);
					this.ws = new WebSocket(this.socket_url);
					this.listen();
				}
			} catch(e) {
				this.reconnectWebSocket();
			}
		},
		// 初始化
		listen(){
			let _this = this;
			if (!_this.ws && _this.ws.readyState != WebSocket.OPEN) return false;
			_this.ws.onopen = function () {}
			_this.ws.onmessage = function (data) {
				let res = JSON.parse(data.data)
				if (res.type === 'init'){
					// 登录
					if (_this.ws != null && _this.ws.readyState == WebSocket.OPEN) {
						// console.log(_this.userInfo)
						let t = JSON.stringify({type: "login", token: _this.userInfo.token})
						_this.ws.send(t);
						// console.log('send', t);
					} else {
						console.log("WebSocket 连接没有建立或已关闭");
					}
				}else{
					_this.ChatEnvent(res);
				}
				// 开启心跳
				if (!_this.socket_heart && _this.ws && _this.ws.readyState == WebSocket.OPEN){
					_this.socket_heart = setInterval(function () {
						let t = JSON.stringify({type: 'heart'})
						_this.ws.send(t);
					}, 30000)
				}
			}
			_this.ws.onclose  = function (data) {
				_this.reconnectWebSocket();
			}
			_this.ws.onerror  = function (data) {
				_this.reconnectWebSocket();
			}
		},
		// 重连
		reconnectWebSocket() {
			let _this = this;
			if(_this.lockReconnect) return;
			_this.lockReconnect = true;
			setTimeout(function(){
				console.log("WebSocket 尝试重新连接");
				_this.lockReconnect = false;
				_this.connSocket();
			}, 5000)
		},
		// socket事件
		ChatEnvent(res) {
			let _this = this
			if (res.type == 'receive'){
				if(this.user_info.info.id!=res.content.uinfo.user_id){
					this.$tool.playMessageAudio();
						
				}
				res.content.msg = res.content.msg.replace(/\n/g,"<br>");
				this.messageList.push(res.content);
				setTimeout(function() {
					_this.scrollEnd()
				});
				this.sendS('read', res.content.record_id, 0);
			}else if (res.type == 'login'){
				// 拉取聊天记录
				this.$api["post2"]("chat/records", {page:this.param.page,limit:this.param.limit,clear:1,cid:this.param.conversation_id}, 1).then(({
					data
				}) => {
					for (var i = 0; i <data.data.length; i++) {
						data.data[i].msg = data.data[i].msg.replace(/\n/g,"<br>");
					}
					_this.messageList = data.data;
					setTimeout(function() {
						_this.scrollEnd()
					}, 100);
				})
			}
			return true
		},
		sendS(action, content, content_type){
			let msg = {type:action};
			if(action == 'send'){

			}else if(action == 'read') {
				msg.record_id = content
			}
			this.ws.send(JSON.stringify(msg));
			this.content = '';
		},
		// connSocket_bak() {
		// 	this.ws = io('wss://zsws.inspector.ltd', {
		// 		query: {
		// 			token: this.chat_token
		// 		},
		// 		transports: ['websocket'],
		// 		autoConnect: true,
		// 	});
		// 	//console.log(`normal_chat#${this.user_info.info.id}`)
		// 	this.ws.emit('subcribe', {
		// 		channel: `normal_chat#${this.user_info.info.id}`,
		// 		data: {
		// 			...this.user_info.info,
		// 			token: this.chat_token
		// 		},
		// 	});
				
		// 		this.ws.emit('subcribe', {
		// 		channel: `group_chat#${this.user_info.group_id}`,
		// 		data: {group:{id:this.user_info.group_id},user_token: this.chat_token},
		// 	}); 
		// 	this.ws.on('chat_new_message', (data) => {
		// 		//console.log(data,"===data===")
		// 		data.record= {
		// 				id: 0,
		// 				content: data.content,
		// 				type: 0,
		// 				sender: 0,
		// 				created_at: "",
		// 				sender_realname: "",
		// 				brief: this.content
		// 			}
		// 		data.direction='reverse';
		// 		if(this.user_info.info.id!=data.sender_info.id){
		// 			data.direction="forward";
		// 			this.$tool.playMessageAudio();
		// 			let that = this
		// 			setTimeout(function() {
		// 				that.scrollEnd()
		// 			});
						
		// 			this.messageList.push(data);
		// 		}
				
		// 	});
		// 	this.getGroupLists();
		// },
		openIndex() {
			let urlObj = this.$router.resolve({
				path: '/index/index'
			})
			window.open(urlObj.href, '_blank')
		},
		// getMsg(msg) {
		// 	if (msg.indexOf('<img') != -1) {
		// 		this.showmessage = msg
		// 		this.dialogVisible = true
		// 	}
		// },
		// onEditorChange() { // 内容改变事件
		// 	//判断是否有回车事件
				
		// 	let msg = this.content
		// 	msg = msg.replace(/<p>/g, '')
		// 	msg = msg.replace(/<\/p>/g, ',')
		// 	msg = msg.split(',')
		// 	// this.content = this.content.replace(/<p><br><\/p>/g,'')
		// 	// console.log(this.content)
		// 	if (msg[0] != '<br>' && msg[0] != '' && msg.includes('<br>')) {
		// 		this.content = this.content.replace('<p><br></p>', '')
		// 		this.sendMsg()
		// 	} else {
		// 		this.content = this.content.replace(/<p><br><\/p>/g, '')
		// 	}
		// },
		//弹窗关闭
		close() {
			this.handleShow = false
			this.$emit("close", false);
		},

		//添加快速回复内容
		// getText() {
		// 	this.dialogTemplate = true
		// },
		// async getGroupLists(status) {
		// 	this.param.conversation_id = this.user_info.conversation_id;
		// 	this.$api["get"]("chat/records", this.param, 1).then(({
		// 		data
		// 	}) => {
		// 		if(data.code==-1||data.code==-2){
		// 			return;
		// 		}
		// 		//console.log(data,"==data==")
		// 		this.messageList = data.data.list;
					
		// 		if(this._isMobile()){
		// 				this.setPageScrollTo()
		// 			//创建监听内容部分滚动条滚动
		// 				this.$refs.scrollBox.addEventListener('scroll',this.srTop);
		// 		}else{
		// 			this.handlelog = true
		// 			let that = this;
		// 			setTimeout(function() {
		// 				that.scrollEnd()
		// 			})
		// 		}
				
		// 	});

				
		// },

		async sendMsg() {
			if (this.content == '') {
				this.$message.warning('发送内容不能为空，请重新输入')
				return
			}
			
			var sdata= {
				content: this.content,
				send_to: this.user_info.conversation_id
			}
			this.content = "";
			this.$api["post2"]("chat/send/group",sdata, 1).then(res => {
				// this.content = "";
			});

		},
		scrollEnd: function() {
			//添加完消息 跳转到最后一条
			this.$nextTick(() => {
				this.$refs['chat-content'].scrollTop = this.$refs['message-wrapper'].scrollHeight
			})
		}
	},
	destroyed() {
		clearInterval(this.timer);
		this.timer = null
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.chat-dialog {
		z-index: 0;

	}

	.inputFocus {
		background-color: #fff !important;
	}

	.edit_container textarea {
		width: 100%;
		height: 108px;
		border: 0;
		background-color: transparent;
		resize: none;
		outline: none;
		padding-right: 10px;
	}

	.kefu-info {
		width: 300px;
		height: 100%;
		// position: absolute;
		// top: 0;
		// right: 0;
		padding: 20px;
		background: #f9fafd;
		z-index: 99999;
        flex-shrink: 0;
		position: relative;

		li {
			margin: 15px 0;
			i{margin-right: 5px;}

			.iconitem {
				display: inline-block;
				vertical-align: middle;
				width: 40px;
				height: 40px;
			}

			.icon-email {
				background: url("../assets/images/youjian.png") no-repeat 100% 100%;
			}

			.icon-phone {
				background: url("../assets/images/zuoji.png") no-repeat 100% 100%;
			}

			.icon-face {
				background: url("../assets/images/face-book.png") no-repeat 100% 100%;
			}

			img {
				width: 100px;
			}
		}
	}

	.chat-box {
        width: 100%;
        height: 100%;
		// margin: 0 auto;
		background: #eee;
		// position: relative;
        display: flex;
        justify-content: space-between;
		// top: 10vh;
		// height: 590px;
        overflow: hidden;
		& /deep/ .el-dialog__wrapper {
			position: absolute;
			z-index: 20011 !important;

			overflow: hidden;

			.el-dialog {
				margin: 0 !important;
				background: #F5F5F5 !important;
			}
		}

		// box-shadow: 0px 0px 10px #dad6d6;
	}

	.msgItem {
		display: inline-block;
		margin-top: 5px;
		vertical-align: top;
		background: #12B7F5;
		color: #fff;
		padding: 7px;
		border-radius: 5px;
		text-align: left;

		img {
			width: 100px;
		}
	}
	.message-ep{ font-size: 12px; color: #999;}

	.ql-toolbar.ql-snow+.ql-container.ql-snow {
		max-height: 70px;
	}

	.sendMsg {
		position: absolute;
		bottom: 15px;
		right: 15px;
	}

	/deep/ .ql-toolbar {
		text-align: left;
	}

	/deep/ .edit_container {
		height: 100%;
		padding: 5px;
	}

	/deep/ .quill-editor {
		height: 100%;
	}

	.footer {
		border: none;
	}

	/deep/ .footer .message-wrap {
		padding: 0px;
		position: relative;
	}

	.M_text {
		position: absolute;
		top: 11px;
		left: 172px;
		font-weight: 600;
		font-size: 16px;
		color: rgb(51, 51, 51);
		cursor: pointer;
	}

	/deep/ .ql-toolbar.ql-snow {
		border: none;
	}

	/deep/ .ql-container.ql-snow {
		border: none;
	}

	/deep/ .ql-container {
		height: 70%;
	}

	.chat-content {
		position: relative;
		height: 100%;
		border: none;
		border-bottom: 1px solid #eee;
		overflow-y: auto;
		padding: 0 10px 10px 10px;
	}
    .chat{
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
    }

	.Merchandiser {
		position: absolute;
		top: 5px;
		right: 5px;
	}

	/deep/ .ql-editor {
		height: 70px;
		width: 100%;
	}

	/deep/ .ql-editor img {
		width: 50px;
		height: 50px;
	}

	.message-item {
		width: 100%;
		margin-bottom: 20px;
		.show-time-box{
			text-align: center;
			line-height: 40px;
			.time-tip{
				border-radius: 2px;
				padding: 3px 6px;
				color: #fff;
				background-color: #ccc;
				font-size: 12px;
			}
		}
		.message{
			max-width: 80%;
		}
		.reverse{
			.el-avatar{
				float: right;
			}
			.message{
				float: right;
				padding-right: 10px;
			}
		}
		.forward{
			.el-avatar{
				float: left;
			}
			.message{
				/* float: left; */
			}
		}
	}

	.my-msg {
		// text-align: right;
		float: right;
	}

	.my-msg>div {
		float: right;
		text-align: right;
		width: 100%;
	}

	.my-msg .content {
		text-align: left;
		width: 100%;
	}

	.your-msg {
		text-align: left;
		float: left;

		.msgItem {
			color: #232323 !important;
			background-color: #ffffff !important;
			border: 1px solid #EDEDED !important;
		}
	}

	.your-msg>div {
		text-align: left;
	}

	/deep/ .content img {
		max-width: 100% !important;
	}

	/deep/ .el-dialog__header {
		height: 60px;
	}

	.head {
		overflow: hidden;
		text-align: center;
		margin-top: -10px;
	}

	.badge_item {
		margin-top: 10px;
		margin-right: 40px;
		float: left;
	}

	/deep/ .el-dialog .el-dialog__header .el-dialog__headerbtn {
		z-index: 1000000;
	}
	/deep/ .dialog__body{ padding: 25px 20px; }

	/deep/ .showImg {
		img {
			max-width: 100% !important;
		}

		.el-dialog__header {
			height: 40px !important;
			background: #6f6f6f !important;
		}

		.el-dialog__body {
			margin: 0 !important;
		}
	}

	/deep/ .ql-editor {
		padding: 0px 15px;
	}

	@media screen and (max-width: 720px) {
		.chat-box {
			width: 90%;
			display:none;
		}

		.kefu-info {
			display: none;
		}
		 
	}
	
</style>

<style scoped>
.wrap {
  height: 100%;
  width: 100%;
  position: relative;
}
.title {
  height: 40px;
  width: 100%;
  background-color: #eaeaea;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bottom {
  min-height: 50px;
  width: 100%;
  border-top: 1px solid #eaeaea;
  position: fixed;
  bottom: 0;
}
.content_box {
  /* 
  中间栏计算高度，110是包含了上下固定的两个元素高度90
  这里padding：10px造成的上下够加了10，把盒子撑大了，所以一共是20要减掉
  然后不知道是边框还是组件的原因，导致多出了一些，这里再减去5px刚好。不然会出现滚动条到顶或者底部的时候再滚动的话就会报一个错，或者出现滚动条变长一下的bug
  */
  height: calc(100% - 115px);
  overflow: auto;
  padding: 10px;
  padding-bottom:100px;
}
.timer {
  text-align: center;
  color: #c2c2c2;
}

/* 发送的信息样式 */
/* 
右边消息思路解释：首先大盒子userbox内放两个盒子，一个放头像，一个放用户名和发送的内容，我们先用flex让他横向排列。
然后把写文字的大盒子设置flex：1。这个属性的意思就是让这个元素撑满父盒子剩余位置。然后我们再把文字盒子设置flex，并把他对齐方式设置为尾部对齐就完成了基本的结构，然后微调一下就可以了
*/
.userbox {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
}
.nameInfo {
  /* 用flex：1把盒子撑开 */
  flex: 1;
  margin-right: 10px;
  /* 用align-items把元素靠右对齐 */
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.contentText {
  background-color: #9eea6a;
  /* 把内容部分改为行内块元素，因为盒子flex：1把盒子撑大了，所以用行内块元素让内容宽度不根据父盒子来 */
  display: inline-block;
  /* 这四句是圆角 */
  border-top-left-radius: 10px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  /* 最大宽度限定内容输入到百分61换行 */
  max-width: 61%;
  padding: 5px 10px;
  /* 忽略多余的空白，只保留一个空白 */
  white-space: normal;
  /* 换行显示全部字符 */
  word-break: break-all;
  margin-top: 3px;
  font-size: 14px;
}

/* 接收的信息样式 */
/* 
左边消息思路解释：跟上面一样，就是换一下位置，首先通过把最外层大盒子的排列方式通过flex-direction: row-reverse;属性翻转，也就是头像和文字盒子换位置
然后删除掉尾部对齐方式，因为不写这个默认是左对齐的。我们写的左边就没必要再写了。
*/
.userbox2 {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 10px;
}
.nameInfo2 {
  /* 用flex：1把盒子撑开 */
  flex: 1;
  margin-left: 10px;
}
.contentText2 {
  /* background-color: #9eea6a; */
  background-color: #eaeaea;
  /* 把内容部分改为行内块元素，因为盒子flex：1把盒子撑大了，所以用行内块元素让内容宽度不根据父盒子来 */
  display: inline-block;
  /* 这四句是圆角 */
  border-top-left-radius: 0px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  /* 最大宽度限定内容输入到百分61换行 */
  max-width: 61%;
  padding: 5px 10px;
  /* 忽略多余的空白，只保留一个空白 */
  white-space: normal;
  /* 换行显示全部字符 */
  word-break: break-all;
  margin-top: 3px;
  font-size: 14px;
}
</style>
 
 